import React, {useEffect, useState} from 'react';
import {Mappr} from '@mappr/react-lib';
import './App.scss';
import {getDomain} from './utils/envUtils';
import {SimulatorSearch} from './components/SimulatorSearch/SimulatorSearch';
import ListLoader from './components/ListLoader/ListLoader';
import {Container} from 'react-bootstrap';

const App = () => {
    const [domain, setDomain] = useState<string>();
    useEffect(() => {
        const d = getDomain();
        setDomain(d);
    }, []);
    return (
        <div className="App">
            {domain && (
                <Mappr
                    name={domain}
                    mprApiUrl={process.env.REACT_APP_MPR_API_URL!}
                    mprGqlUrl={process.env.REACT_APP_MPR_GQL_URL!}
                    mprTileUrl={'https://api.mappr.xyz'}
                    apiUrl={
                        process.env.REACT_APP_MPR_GQL_URL!
                    }
                    language={'fr'}
                >
                    {(configs, callbacks) => (
                        <Container fluid className="simulator h-100">
                            {configs.loading ? <ListLoader/> : <SimulatorSearch project={configs.project}/>}
                        </Container>
                    )}
                </Mappr>
            )}
        </div>

    );
};

export default App;
